import React, { useState, useEffect } from 'react'
import { Modal, Form, Radio, Input, Spin, App, Space } from 'antd';
import Icon from '../../cpn/Icon';
import { useTDbohuiMutation, useTDupdatecontentMutation } from '../../store/DianShangYeWuApi';

function ReportCheckNodeApproveEdit(props) {
    console.log(props.sortedData);
    const {message} = App.useApp();
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [updateIsFetching, setUpdateIsFetching] = useState(false);
    const [bohui] = useTDbohuiMutation();
    const [updateContent] = useTDupdatecontentMutation();
    useEffect(() => {              
        form.setFieldsValue({
            dsbzd_sp_state: props.dsbzd_sp_state ==='4'?'4':'3',
            dsbzd_sp_content: props.dsbzd_sp_content,
        });
    }, [
        props.dsbzd_sp_id, 
        props.dsbzd_sp_jd_xuhao, 
        props.dsbzd_sp_jd_name, 
        props.dsbzd_sp_yh_id, 
        props.dsbzd_sp_yh_name, 
        props.dsbzd_sp_uid, 
        props.dsbzd_sp_uname, 
        props.dsbzd_sp_state, 
        props.dsbzd_sp_content, 
        props.sortedData,
        props.dsbzd_sp_state_time,
        form
    ]);
    return (
        <>
            <a style={{fontSize:"14px"}} onClick={() => {setOpen(true);}}>
                <Space orientation='vertical' size={1}>
                    <span style={{color:props.dsbzd_sp_state==='4' ? 'red' : 'green',fontWeight:"bold"}}>
                        {props.dsbzd_sp_state==='4' ? '驳回' : '同意'}
                        {props.dsbzd_sp_content? '：'+props.dsbzd_sp_content :''}
                    </span>
                    <span>{props.yh_name} {props.dsbzd_sp_state_time} </span>
                </Space>
            </a>
            <Modal 
                open={open} 
                onCancel={() => {
                    setOpen(false);
                    setUpdateIsFetching(false);
                }} 
                footer={null}
                title='审批团队报账单'
            >
                <Spin spinning={updateIsFetching} tip="审批中...">
                    <Form
                        form={form}
                        name="form_client"
                        initialValues={{modifier: 'public',}}
                        labelCol={{ span: 5}}
                        wrapperCol={{ span: 19 }}
                        onFinish={(value) => {
                            if((value.dsbzd_sp_state === '3' && props.dsbzd_sp_state === '3') || (value.dsbzd_sp_state === '4' && props.dsbzd_sp_state === '4') || (value.dsbzd_sp_state === '3' && props.dsbzd_sp_state==='5')){
                                updateContent({
                                    'dsbzd_sp_id': props.dsbzd_sp_id,
                                    'dsbzd_sp_content': value.dsbzd_sp_content,
                                    'dsbzd_sp_yh_id': props.dsbzd_sp_yh_id,
                                    'dsbzd_sp_yh_name': props.dsbzd_sp_yh_name
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('说明修改成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('说明修改失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                                return;                            
                            }else if(value.dsbzd_sp_state === '4' &&  props.dsbzd_sp_state === '3'){
                                bohui({
                                    'dsbzd_sp_id': props.dsbzd_sp_id,
                                    'dsbzd_id': props.dsbzd_id,
                                    'dsbzd_sp_yh_id': props.dsbzd_sp_yh_id,
                                    'dsbzd_sp_content': value.dsbzd_sp_content
                                }).then((res) => {
                                    if(res.data.Status === 'success'){
                                        message.success('驳回成功');
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }else{
                                        message.error('驳回失败'+res.data.Message);
                                        setUpdateIsFetching(false);
                                        setOpen(false);
                                    }
                                });
                            }else{
                                console.log(props.dsbzd_sp_state, value.dsbzd_sp_state);
                                
                                if(props.dsbzd_sp_state === '5' && value.dsbzd_sp_state === '4'){
                                    message.error('已结束的单据不能驳回！')
                                }else if(props.dsbzd_sp_state === '4' && value.dsbzd_sp_state === '3'){
                                    message.error('已驳回的单据不能同意审批！')
                                }
                                setUpdateIsFetching(false);
                            }
                         
                        }}
                    >
                    <Form.Item label='团队名称'>
                        <span>{props.dsbzd_name}</span>
                    </Form.Item>
                    <Form.Item name="dsbzd_sp_state" label="审批意见">
                        <Radio.Group>
                            <Radio value="3">同意</Radio>
                            <Radio value="4">驳回</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item name="dsbzd_sp_content" label="说明">
                        <Input.TextArea rows={4} />
                    </Form.Item>
                    <Form.Item wrapperCol={{ offset: 5, span: 19 }}>
                        <Icon type="save"  onClick={() => {
                            // 弹出加载中Spin
                            setUpdateIsFetching(true);
                            form.submit();
                        }}/>
                    </Form.Item>
                </Form>
                </Spin>
            </Modal>
        </>
    )
}

export default ReportCheckNodeApproveEdit